import styled, { css } from 'styled-components';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { Typography } from '@/components/Typography';
import { textUnderlineOnHover } from '@/theme';

export const Wrapper = styled(LinkWithLocale)`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  position: relative;
  svg {
    width: 72px;
    height: 72px;
  }

  ${({ theme }) => css`
    background-color: ${theme.colors.lightGrey};
    height: 120px;

    ${theme.media.md.up} {
      height: 160px;
      width: 240px;
      padding-top: ${theme.spacing(3)};
    }
  `}

  ${textUnderlineOnHover};
`;

export const ImageWrapper = styled.div`
  min-width: 42px;
  height: 48px;
  max-width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-height: 100%;
    max-width: 100%;
  }
`;

export const Label = styled(Typography)`
  &&& {
    text-transform: uppercase;
    text-align: center;

    ${({ theme }) => css`
      color: ${theme.colors.secondary};
      font-family: ${theme.fontFamilies.italianPlate};
      font-size: ${theme.fontSizes.p2};
      padding-top: ${theme.spacing(1)};

      ${theme.media.md.up} {
        font-size: ${theme.fontSizes.p1};
      }
    `}
  }
`;
